import React, {useEffect, useCallback, useState} from 'react';
import 'pure-react-carousel/dist/react-carousel.es.css';
import 'video.js/dist/video-js.css';

import ShowMoreText from 'react-show-more-text';
import videojs from 'video.js';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
} from 'react-share';
import {
    CarouselProvider,
    Slider,
    Slide,
    ButtonBack,
    ButtonNext,
} from 'pure-react-carousel';
import nextArrowImg from '../images/next-arrow.svg';
import {NavLink} from '../components/atoms';

import {graphql} from 'gatsby';
import {isWindowNotUndefined, shuffleArray, useWindowSize} from "../components/helpers";
import VideoStyles from "../components/organisms/VideoPlayer/VideoStyles";
import Layout from "../components/layout";

export const query = graphql`
    query($id: String!, $playlistId: String!) {
        video(id: { eq: $id }) {
            afvcom_title
            cdn_or_afvurl
            asset_id
            afvcom_description
            keywords{
                value
            }
        }
        allPlaylist(
            filter: {id: {eq: $playlistId}}
        ){
            nodes{
                homepageVideos{
                    asset_id
                    thumbnail_url
                }
            }
        }
    }
`;

const Video = ({data}) => {
    const bootstrapVideoPlayer = useCallback((src, videoId) => {
        const options = {
            autoplay: true,
            width: 700,
            height: 500,
            controls: true,
            sources: [{
                src: src,
            }],
            controlBar: {
                children: [
                    'playToggle',
                    'volumePanel',
                    'currentTimeDisplay',
                    'timeDivider',
                    'durationDisplay',
                    'progressControl',
                    'liveDisplay',
                    'seekToLive',
                    'remainingTimeDisplay',
                    'customControlSpacer',
                    'playbackRateMenuButton',
                    'chaptersButton',
                    'descriptionsButton',
                    'subsCapsButton',
                    'audioTrackButton',
                    'fullscreenToggle',
                ],
            },
        };
        return videojs(videoId, options);
    }, []);

    useEffect(() => {
        const playerInstance = bootstrapVideoPlayer(
            data.video.cdn_or_afvurl,
            'video-player'
        );
        return () => {
            playerInstance.dispose();
        }
    }, [bootstrapVideoPlayer]);

    const getRelatedVideoItems = () => {
        if (data.allPlaylist && data.allPlaylist.nodes[0] && data.allPlaylist.nodes[0].homepageVideos && data.video && data.video.asset_id) {
            let relatedVideos = data.allPlaylist.nodes[0].homepageVideos;
            return relatedVideos.filter(video => video.asset_id && video.asset_id !== data.video.asset_id);
        }
        return [];
    }

    const relatedVideoItems = getRelatedVideoItems();

    const [videoDescription, setVideoDescription] = useState(data.video.afvcom_description);
    const [shareIcons, setShareIcons] = useState('');
    const [relatedVideos, setRelatedVideos] = useState('');

    useEffect(() => {
        //html that cant be rendered on server side (needs calculations on client side)
        setVideoDescription(
            data.video.afvcom_description ?
                <ShowMoreText
                    lines={4}
                    more="Show more"
                    less="Show less"
                    anchorClass="show-more-text"
                    expanded={false}
                >
                    <p className="video-description">
                        {data.video.afvcom_description}
                    </p>
                </ShowMoreText>
                : null)

        setShareIcons(<div className="share-buttons-container columns">
            <h3 className="title is-4">Share</h3>
            <FacebookShareButton url={url.href} className={"SocialMediaShareButton"}>
                <FacebookIcon size={45} round/>
            </FacebookShareButton>
            <TwitterShareButton url={url.href} className={"SocialMediaShareButton"}>
                <TwitterIcon size={45} round/>
            </TwitterShareButton>
            <WhatsappShareButton url={url.href} className={"SocialMediaShareButton"}>
                <WhatsappIcon size={45} round/>
            </WhatsappShareButton>
        </div>)

        setRelatedVideos(
            relatedVideoItems.length > 0 ?
                <div className="carousel-container">
                    <h3 className="title up-next is-4">Up Next</h3>
                    <CarouselProvider
                        naturalSlideWidth={
                            isLaptopSize() && !isPhoneSize() ? 500 : 300
                        }
                        naturalSlideHeight={
                            isLaptopSize() && !isPhoneSize() ? 500 : 200
                        }
                        totalSlides={15}
                        visibleSlides={
                            isMediumSize() && !isPhoneSize() ? 2 : isPhoneSize() ? 1 : 3
                        }
                        orientation={
                            isLaptopSize() && !isPhoneSize()
                                ? 'horizontal'
                                : isPhoneSize()
                                ? 'horizontal'
                                : 'vertical'
                        }
                        style={{
                            width: isLaptopSize() && !isPhoneSize() ? 680 : 250,
                            height: 'auto',
                            marginLeft: isLaptopSize() && !isPhoneSize() ? 0 : 40,
                            position: 'relative',
                        }}
                    >
                        <Slider>
                            {shuffleArray(relatedVideoItems).map(video => {
                                return (
                                    <Slide key={video.asset_id}>
                                        <NavLink to={`video/${video.asset_id}`}>
                                            <div
                                                style={{
                                                    height: 140,
                                                    width: 220,
                                                    overflow: 'hidden',
                                                    borderRadius: '10px',
                                                    marginBottom: '0px',
                                                    marginTop: '0px',
                                                }}
                                            >
                                                <img src={video.thumbnail_url}/>
                                            </div>
                                        </NavLink>
                                    </Slide>
                                );
                            })}
                        </Slider>
                        <ButtonBack className="carousel-button">
                            <img className="carousel-back-arrow" src={nextArrowImg}/>
                        </ButtonBack>
                        <ButtonNext className="carousel-button">
                            <img className="carousel-next-arrow" src={nextArrowImg}/>
                        </ButtonNext>
                    </CarouselProvider>
                </div>
                : null
        )
    }, []);

    const windowSize = useWindowSize();
    const isLaptopSize = () => windowSize.width <= 1024;
    const isMediumSize = () => windowSize.width <= 720;
    const isPhoneSize = () => windowSize.width <= 550;
    const url = isWindowNotUndefined() ? new URL(window.location.href) : null;

    return (
        <Layout>
            <VideoStyles>
                <div>
                    <div data-vjs-player>
                        <video
                            id="video-player"
                            className="video-js vjs-default-skin vjs-big-play-centered"
                            width="100%"
                            height="100%"
                        />
                    </div>
                    <div>
                        <div className="video-collective-container">
                            <div className="video-assets-container">
                                <div className="video-info columns ">
                                    <h1 className="main-title">{data.video.afvcom_title ? data.video.afvcom_title : ''}</h1>
                                    {/* Video Description Show More Text */}
                                    <div className="show-more-container">
                                        {videoDescription}
                                    </div>
                                    {data.video.keywords ?
                                        <div className="video-info-clickables">
                                            {shareIcons}
                                            <div className="tags-container">
                                                <ul
                                                    className="buttons are-large"
                                                    style={{
                                                        width: '680px',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                    }}
                                                >
                                                    <li>
                                                        <h3 className="title is-4">Keywords</h3>
                                                    </li>
                                                    {data.video.keywords.map((keyword, index) => (
                                                        // eslint-disable-next-line react/no-array-index-key
                                                        <li
                                                            className="keyword-container button is-white is-outlined is-rounded"
                                                            key={`${keyword}-${index}`}
                                                        >
                                                            <span className="keyword-name">{keyword.value}</span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        : ''}
                                </div>
                                {relatedVideos}
                            </div>
                        </div>
                    </div>
                </div>
            </VideoStyles>
        </Layout>
    );
};

export default Video;
